/**
 * @fileoverview Result Controller - リザルト表示管理
 */

import { GameStatus } from '../../core/constants.js';
import { STATE_PATHS } from '../../shared/constants/state-paths.js';

import { onPathChange } from './subscription-utils.js';

/**
 * リザルト表示の可視性を計算
 * 純粋関数: GameStateを読み取り専用で使用
 */
export function calculateResultVisibility(gameState) {
  const coreState = gameState.getState('core');

  const flags = {
    isPaused: coreState.status === GameStatus.Paused,
  };

  const visibility = {
    // Pausedシーン中は非表示、それ以外は表示
    visible: !flags.isPaused,
  };

  return { visibility, flags };
}

/**
 * リザルト表示のDOM更新
 * 純粋関数: DOM操作のみ、状態変更なし
 */
export function updateResultDisplay(gameState) {
  const resultElement = document.getElementById('result-info');
  if (!resultElement) return; // リザルト表示がない場合は何もしない

  const { visibility } = calculateResultVisibility(gameState);

  // CSSクラスベースで制御（既存パターンに合わせる）
  resultElement.classList.toggle('is-paused-hidden', !visibility.visible);

  // Result display updated - no logging needed
}

/**
 * リザルトコントローラーの初期化
 * GameStateの変更を監視してリザルト表示を自動更新
 */
export function initializeResultController(gameState) {
  // シーン変更のみを監視（Pausedシーンでの表示制御、境界バグ回避版）
  return onPathChange(
    gameState,
    STATE_PATHS.CORE_STATUS,
    () => {
      updateResultDisplay(gameState);
    },
    true,
  );
}
